import { CATEGORIAS } from "./types";

export const state: CATEGORIAS = {
  AT_COD: "",
  AT_DESC: "",
  Imagen: ""
};

